export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8085.549b76a8.jpg";